import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach bearer if present (fallback for cross-domain cookie edge cases)
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("session_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const downloadPdf = async (path, filename) => {
  const res = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url; a.download = filename; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
};

export const readImageDataUrl = (file, maxBytes = 700 * 1024) =>
  new Promise((res, rej) => {
    if (!file) return rej(new Error("Sin archivo"));
    if (!file.type.startsWith("image/")) return rej(new Error("Debe ser una imagen PNG o JPG"));
    if (file.size > maxBytes) return rej(new Error("Máximo 700KB. Comprime la imagen."));
    const r = new FileReader();
    r.onload = () => res(r.result);
    r.onerror = () => rej(new Error("No se pudo leer la imagen"));
    r.readAsDataURL(file);
  });
